import { render, staticRenderFns } from "./ResourceTypeVideo.vue?vue&type=template&id=1af8d665&"
import script from "./ResourceTypeVideo.vue?vue&type=script&lang=js&"
export * from "./ResourceTypeVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports